module.exports = __webpack_public_path__ + "media/images/logo_text_pl-b28bdff90c2d4afc310653f68aafc5f4.svg";